import { render, staticRenderFns } from "./OnboardingCentralSecondaryBanner.vue?vue&type=template&id=20296856&scoped=true"
import script from "./OnboardingCentralSecondaryBanner.vue?vue&type=script&lang=js"
export * from "./OnboardingCentralSecondaryBanner.vue?vue&type=script&lang=js"
import style0 from "./OnboardingCentralSecondaryBanner.vue?vue&type=style&index=0&id=20296856&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20296856",
  null
  
)

export default component.exports